import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
} from "@mui/material";

const SqlEditorDialog = ({
  open,
  selectedSqlFile,
  sqlEditorContent,
  sqlEditorLoading,
  sqlEditorError,
  sqlSaveLoading,
  sqlSaveMessage,
  activeChange,
  onClose,
  onChangeSqlEditorContent,
  onSaveSqlEditor,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {selectedSqlFile?.path ||
          selectedSqlFile?.filename ||
          "Edit SQL file"}
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="caption" color="text.secondary">
          Editing SQL migration for change #
          {activeChange && activeChange.id ? activeChange.id : "?"}.
        </Typography>
        <TextField
          margin="dense"
          fullWidth
          multiline
          minRows={12}
          value={sqlEditorContent}
          onChange={(e) => onChangeSqlEditorContent(e.target.value)}
          disabled={sqlEditorLoading}
          sx={{
            mt: 2,
            fontFamily: "monospace",
            "& .MuiInputBase-input": { fontFamily: "monospace" },
          }}
        />
        {sqlEditorError && (
          <Typography
            variant="caption"
            color="error"
            sx={{ display: "block", mt: 1 }}
          >
            {sqlEditorError}
          </Typography>
        )}
        {sqlSaveMessage && (
          <Typography
            variant="caption"
            color="success.main"
            sx={{ display: "block", mt: 1 }}
          >
            {sqlSaveMessage}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          disabled={sqlSaveLoading || sqlEditorLoading}
        >
          Close
        </Button>
        <Button
          onClick={onSaveSqlEditor}
          variant="contained"
          disabled={sqlSaveLoading || sqlEditorLoading}
        >
          {sqlSaveLoading ? "Saving..." : "Save SQL"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SqlEditorDialog;